import { SET_UPCOMING_APPOINTMENTS } from '../actions/appointments';

const initialState = {
  upcomingAppointments: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_UPCOMING_APPOINTMENTS:
      return {
        ...state,
        upcomingAppointments: payload,
      };
    default:
      return state;
  }
};
